import { useTheme, useMediaQuery } from '@mui/material';
import { Breakpoint } from '@mui/material/styles';

/**
 * Hook único para detectar viewport mobile, padronizando a checagem que antes
 * era reescrita inline em vários componentes (Navbar, AdminLayout, etc.).
 *
 * @param breakpoint Limite superior do "mobile". Padrão 'sm' (< 600px), que
 *   cobre celulares. Use 'md' (< 900px) para incluir tablets em layouts que
 *   precisam colapsar mais cedo (ex.: sidebars).
 *
 * @example
 *   const isMobile = useIsMobile();          // < 600px
 *   const isCompact = useIsMobile('md');     // < 900px
 */
export function useIsMobile(breakpoint: Breakpoint = 'sm'): boolean {
  const theme = useTheme();
  // noSsr evita o flash de layout desktop no primeiro render no cliente.
  return useMediaQuery(theme.breakpoints.down(breakpoint), { noSsr: true });
}

export default useIsMobile;
